module.exports = __webpack_public_path__ + "img/businessman3.fbb58a99.svg";